import { SVGProps } from 'react'

export function ChevronRight({ width = 24, height = 24, className = '', ...rest }: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className={"feather feather-chevron-right " + className}
            {...rest}
        >
            <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
    )
}
